import FastMarquee from "react-fast-marquee";

const items = ["Confidential", "Secure", "Anonymous", "Moderated", "24/7 Access", "Judgment-free"];

export const Marquee = () => {
  return (
    <section
      className="border-y border-border bg-secondary/60 py-8 md:py-10"
      data-testid="marquee-section"
      aria-hidden
    >
      <FastMarquee speed={38} gradient={false} pauseOnHover>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl font-light text-foreground/80 mx-10 md:mx-16">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-accent" />
          </div>
        ))}
      </FastMarquee>
    </section>
  );
};

export default Marquee;
